import * as Yup from "yup";
import React, { useEffect } from "react";
import FormDefault from "../../components/Forms/FormDefault";
import { Request } from "../../hooks/Request";
import { validateType } from "../../utils/constant";
import { validateArray, validateStatus } from "../../utils/validate";
import { useDialog } from "../../contexts/DialogContext";
import { GenerateQuotesPDF } from "./GenerateQuotesPDF";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";
import {
  adjuntarDex,
  readDam,
  readDim,
  readParte,
} from "../../components/services/ReadFile";
import { TransportContractPdf } from "./TransportContractPdf";
import { InsuranceApplicationPDF } from "./InsuranceApplicationPDF";

import {
  INSURANCE_MATERIAL_UPDATED_EVENT,
  normalizeInsuranceCurrency,
  toInsuranceNumber,
} from "../../utils/insuranceRules";

// const listFields = ["listaDeDocumentosDeRespaldo"];
const listFields = [
  "polizaNro",
  "fechaDeEmbarque",
  "itemsOrdenDeCompra",
  "facturaOProformaODoc",
  "fechaFactura",
  "travesíaDesde",
  "travesíaHasta",
  "medioTransporte",
  "cobertura",
  "tasa",
  "tipoDeCambioSeguroEurUsd",
  "AplicaciónNo",
  //"cantidadDeLaPolizaAgrupada",
  //"unidadDeLaPolizaAgrupada",
  "descripcionDeLaPoliza",
];

const TRAVEL_FROM_FIELD = "travesíaDesde";
const TRAVEL_TO_FIELD = "travesíaHasta";
const TRANSPORT_MODE_FIELD = "medioTransporte";

const FIXED_TRAVEL_TO = "COCHABAMBA, BOLIVIA";

const TRAVEL_FROM_DROPDOWN = "travesiaDesde";
const TRANSPORT_MODE_DROPDOWN = "mediosDeTransporte";

const FIXED_POLICY_NUMBER = "CM - CBR0595503";
// fecha doc, factura

const INSURANCE_RATE_FIELD = "tasa";
const INSURANCE_EUR_USD_RATE_FIELD = "tipoDeCambioSeguroEurUsd";

function safeJsonParse(value, fallback = {}) {
  try {
    if (!value) return fallback;
    return typeof value === "string" ? JSON.parse(value) : value;
  } catch {
    return fallback;
  }
}

function isEmptyValue(value) {
  return value === null || value === undefined || value === "";
}

function getSuggestedInsuranceRate(dataValues) {
  const items = dataValues?.itemsOrdenDeCompraSubDatas || [];

  const itemWithRate = items.find((item) => {
    const extra = safeJsonParse(item.description2);
    return !isEmptyValue(extra?.insuranceRate);
  });

  if (!itemWithRate) return "";

  const extra = safeJsonParse(itemWithRate.description2);

  return String(extra.insuranceRate);
}



export const FormInsuranceApplication = (props) => {
  const { procedure, reload, handleSendProcedure } = props;
  const { openDialog } = useDialog();

  const procedureId = procedure.id || procedure.procedureId;
  const canSendProcedure = Boolean(
    typeof handleSendProcedure === "function" && procedure.processStepId,
  );

  const { data, loading, call } = Request({
    urlApi: `/Procedure/${procedureId}/datasets?${listFields
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const {
    data: insuranceDataValues,
    loading: insuranceDataValuesLoading,
    call: refetchInsuranceDataValues,
  } = Request({
    urlApi: `/Procedure/${procedureId}/dataValues?fieldnames=itemsOrdenDeCompra&fieldnames=moneda`,
  });

  const suggestedInsuranceRate = getSuggestedInsuranceRate(insuranceDataValues);

  const purchaseOrderCurrency = normalizeInsuranceCurrency(
    insuranceDataValues?.moneda || "USD",
  );

  useEffect(() => {
    function handleInsuranceMaterialUpdated(event) {
      const updatedProcedureId = event?.detail?.procedureId;

      if (
        updatedProcedureId &&
        String(updatedProcedureId) !== String(procedureId)
      ) {
        return;
      }

      refetchInsuranceDataValues();
    }

    window.addEventListener(
      INSURANCE_MATERIAL_UPDATED_EVENT,
      handleInsuranceMaterialUpdated,
    );

    return () => {
      window.removeEventListener(
        INSURANCE_MATERIAL_UPDATED_EVENT,
        handleInsuranceMaterialUpdated,
      );
    };
  }, [procedureId, refetchInsuranceDataValues]);

  function dataFields(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]: element.validate
          ? validateType[element.type] || null
          : null,
      };
    });
    return aux;
  }

  function dataIntialValues(list, suggestedInsuranceRate) {
    let aux = {};

    list?.forEach((element) => {
      const savedValue =
        element.initial === "false" ? false : element.initial;

      const value =
        element.name === "polizaNro" && isEmptyValue(savedValue)
          ? FIXED_POLICY_NUMBER
          : element.name === "cobertura" && isEmptyValue(savedValue)
            ? "TODO RIESGO"
            : element.name === TRAVEL_TO_FIELD && isEmptyValue(savedValue)
              ? FIXED_TRAVEL_TO
              : element.name === INSURANCE_RATE_FIELD &&
                  !isEmptyValue(suggestedInsuranceRate)
                ? suggestedInsuranceRate
                : savedValue || "";

      aux = {
        ...aux,
        [element.name]: value,
      };
    });

    return aux;
  }

  function handleOnSubmit() {
    openDialog(
      <InsuranceApplicationPDF
        procedureId={procedure.id || procedure.procedureId}
      />,
    );
  }

  async function handleCreateOption(value, dropdown) {
    await requestAuth("post", "/dropdown/option", {
      Name: value,
      DropdownListLabel: dropdown,
    });
  }

  async function submitDataset(values, resetForm, btnSecondary) {
    await requestAuth("post", "/dataset", values)
      .then(async () => {
        const listRead = values.filter((f) => f.type === "fileRead");
        if (listRead && listRead.length > 0) {
          await readDataProcedure(0, listRead, [], resetForm, btnSecondary);
        } else {
          await handleSubmitSuccess(btnSecondary);
        }
      })
      .catch(() => {
        toast.error("Error en el envio");
      });
  }

  async function handleSubmitSuccess(btnSecondary) {
    if (typeof reload === "function") {
      reload();
    }

    if (btnSecondary && canSendProcedure) {
      toast.success("Datos guardados. Confirme el envío del trámite.");
      await handleSendProcedure(
        { ...procedure, id: procedureId },
        typeof reload === "function" ? reload : () => {},
      );
      return;
    }

    handleOnSubmit();
    toast.success("Envio exitoso");
  }

  async function readDataProcedure(
    index,
    fields,
    result,
    resetForm,
    btnSecondary,
  ) {
    if (index < fields.length) {
      switch (fields[index].url) {
        case "adjuntarDim":
          await readDim(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "dimRegularizada":
          await readDim(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "adjuntarDex":
          await adjuntarDex(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "documentoDam":
          await readDam(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
        case "parteDeRecepcion":
          await readParte(
            fields,
            index,
            procedure,
            result,
            async (indexRecibe, fieldsRecibe, resultRecibe) =>
              await readDataProcedure(
                indexRecibe,
                fieldsRecibe,
                resultRecibe,
                resetForm,
                btnSecondary,
              ),
          );
          break;
      }
    } else {
      const badResult = result.filter(
        (read) => !validateStatus(read.readStatus) && read.validate,
      );
      if (validateArray(badResult)) {
        toast.error(badResult[0].readData);
      } else {
        await handleSubmitSuccess(btnSecondary);
      }
    }
  }

  function validateInsuranceExchangeRate(values) {
    if (purchaseOrderCurrency !== "EUR") {
      return true;
    }

    const exchangeRate = toInsuranceNumber(
      values[INSURANCE_EUR_USD_RATE_FIELD],
    );

    if (exchangeRate <= 0) {
      toast.error(
        "Ingrese un tipo de cambio EUR/USD mayor a 0 para generar la aplicación de seguro.",
      );
      return false;
    }

    return true;
  }

  async function onSubmit(values, resetForm, fields) {
    if (!validateInsuranceExchangeRate(values)) {
      return;
    }

    const result = await Promise.all(
      fields.map(async (element) => {
        if (element.type === "file" || element.type === "fileRead") {
          if (
            (values[element.name] === "" || values[element.name] === null) &&
            (element.initial === "" || element.initial === null)
          ) {
            return null;
          } else if (
            (values[element.name] !== "" && !element.initial) ||
            (values[element.name] !== "" &&
              values[element.name] !== element.initial)
          ) {
            let formData = new FormData();
            formData.append("Name", element.name);
            formData.append("File", values[element.name]);
            formData.append("originalName", values[element.name].name);
            formData.append("Status", "verified");
            formData.append("ProcedureId", procedure.id);
            const fileContents = await requestAuth(
              "post",
              "/files",
              formData,
            ).then((res) => {
              return {
                Value: res.data.url,
                ProcedureId: procedure.id,
                FieldId: element.id,
                FileId: res.data.id,
                name: element.name,
                url: element.url,
                type: element.type,
              };
            });
            return fileContents;
          } else {
            const value =
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "";

            return {
              Value: value,
              ProcedureId: procedure.id,
              FieldId: element.id,
              name: element.name,
              url: element.url,
              type: element.type,
            };
          }
        } else if (
          element.type === "selectNewOption" ||
          element.name === TRAVEL_FROM_FIELD
        ) {
          if (values[element.name + "_isNew"]) {
            await handleCreateOption(
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
              element.name === TRAVEL_FROM_FIELD ? TRAVEL_FROM_DROPDOWN : element.url,
            );
          }
          return {
            Value:
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
            ProcedureId: procedure.id,
            FieldId: element.id,
            name: element.name,
            url: element.url,
            type: element.type,
          };
        } else {
          const value =
            element.name === INSURANCE_RATE_FIELD &&
                  !isEmptyValue(suggestedInsuranceRate)
                ? suggestedInsuranceRate
                : values[element.name] || values[element.name] === 0
                  ? values[element.name]
                  : "";
          return {
            Value: value,
            ProcedureId: procedureId,
            FieldId: element.id,
            name: element.name,
            url: element.url,
            type: element.type,
          };
        }
      }),
    );
    await submitDataset(
      result.filter((n) => n),
      resetForm,
      values.btnSecondary,
    );
  }

  if (!loading || !insuranceDataValuesLoading) {
    return null;
  }

  return (
    <div className="">
      <FormDefault
        key={`insurance-application-${procedureId}-${suggestedInsuranceRate || "no-rate"}`}
        tittle="Formulario de Aplicación del seguro"
        fields={data
          .sort((a, b) => {
            const indexA = listFields.indexOf(a.name);
            const indexB = listFields.indexOf(b.name);
            return indexA - indexB;
          })
          .map((value, index) => {
            const isPolicyNumber = value.name === "polizaNro";
            const isCobertura = value.name === "cobertura";
            const isRate = value.name === INSURANCE_RATE_FIELD;
            const isInsuranceExchangeRate =
              value.name === INSURANCE_EUR_USD_RATE_FIELD;

            const isTravelFrom = value.name === TRAVEL_FROM_FIELD;
            const isTravelTo = value.name === TRAVEL_TO_FIELD;
            const isTransportMode = value.name === TRANSPORT_MODE_FIELD;

            const forcedDropdownUrl = isTravelFrom
              ? TRAVEL_FROM_DROPDOWN
              : isTransportMode
                ? TRANSPORT_MODE_DROPDOWN
                : value.url;

            return {
              ...value,
              id: procedure.id,
              fieldId: value.id,
              label: value.label,
              labelCustom: (
                <>
                  <span className="text-green-600">{index + 1}.</span>{" "}
                  {value.label}
                </>
              ),
              name: value.name,
              validate: isInsuranceExchangeRate && purchaseOrderCurrency !== "EUR"
                ? false
                : value.validate,
              placeholder: isTravelTo
                ? FIXED_TRAVEL_TO
                : isTravelFrom
                  ? "Seleccione travesía desde"
                  : isTransportMode
                    ? "Seleccione medio de transporte"
                    : isPolicyNumber
                      ? FIXED_POLICY_NUMBER
                      : "Complete el campo",
              type: isTravelFrom
                ? "selectNewOption"
                : isTransportMode
                  ? "selectGet"
                : value.type === "fileRead"
                  ? "file"
                  : value.type,
              typeInput: isTravelFrom
                ? "selectNewOption"
                : isTransportMode
                  ? "selectGet"
                : value.type === "fileRead"
                  ? "file"
                  : value.type,
              initial: value.initial ? value.initial : null,
              lockEdition:
                isInsuranceExchangeRate && purchaseOrderCurrency !== "EUR"
                  ? true
                  : value.lockEdition,
              children: isRate && !isEmptyValue(suggestedInsuranceRate) ? (
                <span className="text-xs text-blue-700 mt-1">
                  Tasa sugerida desde clasificación de seguro:{" "}
                  {suggestedInsuranceRate}%
                </span>
              ) : isInsuranceExchangeRate ? (
                <span
                  className={
                    purchaseOrderCurrency === "EUR"
                      ? "text-xs text-orange-700 mt-1"
                      : "text-xs text-gray-500 mt-1"
                  }
                >
                  {purchaseOrderCurrency === "EUR"
                    ? "Obligatorio: se usará para el costo seguro en USD."
                    : "No requerido: la Orden de Compra está registrada en USD."}
                </span>
              ) : undefined,
              urlApi: forcedDropdownUrl
                ? forcedDropdownUrl.includes("/")
                  ? forcedDropdownUrl
                  : `/Dropdown/${forcedDropdownUrl}/options`
                : "",
              urlInitial: forcedDropdownUrl,
              value: "name",
              labelOption: "name",
            };
          })}
        initialValues={dataIntialValues(data, suggestedInsuranceRate)}
        validationSchema={Yup.object().shape(dataFields(data))}
        onSubmit={async (values, resetForm) =>
          await onSubmit(values, resetForm, data)
        }
        buttonName="Guardar"
        buttonSecondary={canSendProcedure}
      />
    </div>
  );
};
